import { render, staticRenderFns } from "./dotManage.vue?vue&type=template&id=20c0498c&"
import script from "./dotManage.vue?vue&type=script&lang=js&"
export * from "./dotManage.vue?vue&type=script&lang=js&"
import style0 from "./dotManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20c0498c')) {
      api.createRecord('20c0498c', component.options)
    } else {
      api.reload('20c0498c', component.options)
    }
    module.hot.accept("./dotManage.vue?vue&type=template&id=20c0498c&", function () {
      api.rerender('20c0498c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dotManage.vue"
export default component.exports